var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_4056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0393 17.8109L19.0435 17.8103L19.1502 11.6987C19.2023 8.70889 18.5989 6.39453 15.1036 6.33352C13.4233 6.30419 12.2796 7.20658 11.804 8.07272L11.7554 8.07187L11.7819 6.55475L8.46778 6.4969L8.27359 17.6223L11.7244 17.6826L11.8206 12.1737C11.8459 10.7232 12.1453 9.3254 13.9416 9.35676C15.7115 9.38765 15.709 11.0434 15.6864 12.3342L15.5919 17.7507L19.0393 17.8109Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84766 6.39941L6.30269 6.45972L6.10849 17.5851L2.65346 17.5248L2.84766 6.39941Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67296 0.891374C3.56826 0.872092 2.65623 1.75283 2.63695 2.85753C2.61766 3.96222 3.49808 4.89301 4.60278 4.9123C5.70747 4.93158 6.61983 4.03208 6.63911 2.92739C6.6577 1.82268 5.77696 0.910645 4.67296 0.891374Z",
    fill: "white",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_4056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1.00391 0.827148) rotate(0.999999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer_linkedin.5b0f8d5611a490b36c0effa301309449.svg";
export { ForwardRef as ReactComponent };